// QRScanner.jsx
import { useEffect, useRef, useState } from "react";
import { BrowserMultiFormatReader } from "@zxing/browser";
import { Card, Col, Row, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"

export default function QRScanner({ onResult }) {
    const videoRef = useRef(null);
    const readerRef = useRef(null);
    const [scanning, setScanning] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        readerRef.current = new BrowserMultiFormatReader();
        return () => {
            // detener si el componente se desmonta
            try { readerRef.current?.reset(); } catch { }
        };
    }, []);

    const startScan = async () => {
        setError("");
        setScanning(true);
        try {
            await readerRef.current.decodeFromConstraints(
                {
                    video: { facingMode: { ideal: "environment" } }, // cámara trasera
                    audio: false,
                },
                videoRef.current,
                (result, err, controls) => {
                    if (result) {
                        const text = result.getText ? result.getText() : result.text;
                        controls.stop();           // detiene la cámara
                        setScanning(false);
                        onResult?.(text);          // <-- aquí te entrego la URL del QR
                    }
                    // 'err' trae intentos fallidos normales de decodificación; no es error fatal
                }
            );
        } catch (e) {
            console.error(e);
            setError("No se pudo abrir la cámara. Revisa permisos/HTTPS.");
            setScanning(false);
        }
    };

    const stopScan = () => {
        try { readerRef.current?.reset(); } catch { }
        setScanning(false);
    };

    return (
        <div>
            <div style={{ display: "flex", gap: 4, marginBottom: 4 }}>
                {!scanning ? (
                    <Button size="sm" onClick={startScan}> <i className="fas fa-qr" ></i>Escanear QR</Button>
                ) : (
                        <Button size="sm"  onClick={stopScan}>Detener</Button>
                )}
            </div>

            {error && <div style={{ color: "red" }}>{error}</div>}

            <video
                ref={videoRef}
                style={{ width: "100%", maxWidth: 100, borderRadius: 12 }}
                muted
                playsInline
                autoPlay
            />
        </div>
    );
}
